module.exports = __webpack_public_path__ + "img/12.fa3181a2.png";